const DESIGN_ROOT_FONT_SIZE_PX = 16

/** Convert a design-space pixel value into a root-scaled CSS length. */
export function designPixelsToRem(value: number): string {
  return `${value / DESIGN_ROOT_FONT_SIZE_PX}rem`
}

/** Current root-font scale relative to the 16 px design baseline. */
export function getRootFontScale(): number {
  if (typeof document === 'undefined') return 1
  const rootFontSize = Number.parseFloat(getComputedStyle(document.documentElement).fontSize)
  if (!Number.isFinite(rootFontSize) || rootFontSize <= 0) return 1
  return rootFontSize / DESIGN_ROOT_FONT_SIZE_PX
}

/** Scale pixel-only third-party APIs, such as Monaco's numeric font size. */
export function designPixelsToScaledPixels(value: number): number {
  return value * getRootFontScale()
}

/** Translate pointer movement back into the unscaled design coordinate space. */
export function screenPixelsToDesignPixels(value: number): number {
  return value / getRootFontScale()
}
